import {
  maxLength,
  required,
  validPolygon,
  polygonInPolygon
} from '../../utils/validation';
import { extractFoobarReference } from '../../utils/foobar';

export const ZoneValidations = {
  zone: [required('models.zone.zone'), maxLength(24, 'models.zone.zone')],
  site: [required('models.zone.site')],
  area: [required('models.zone.area')],
  polygon: [
    required('models.zone.polygon'),
    validPolygon('models.zone.polygon'),
    polygonInPolygon('area.polygon', 'models.zone.polygon', 'models.zone.area')
  ]
};

class Serializer {
  normalize = data => {
    return {
      id: data.id,
      href: data.self.href,
      account: data.account && {
        id: extractFoobarReference(data.account),
        href: data.account.href
      },
      name: data.value,
      site: { id: data.assetInfo.metadata.props.siteId },
      area: { id: data.assetInfo.metadata.props.areaId },
      locationCount: +data.assetInfo.metadata.props.locationCount,
      polygon: data.assetInfo.metadata.props.points
        ? data.assetInfo.metadata.props.points
            .split(';')
            .map(point => point.split(',').map(n => +n))
        : []
    };
  };
  serialize = zone => {
    return {
      configValue: zone.name,
      properties: {
        areaId: zone.area.id,
        siteId: zone.site.id,
        points: zone.polygon
          ? zone.polygon.map(point => point.join(',')).join(';')
          : ''
      }
    };
  };
  serializeForUpdate = zone => {
    return {
      name: zone.name
    };
  };
}

export const ZoneSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/zone/index.js